import StaticPageLayout from "@/components/layout/StaticPageLayout";
import { useLanguage } from "@/context/LanguageContext";

export default function CookiePolicy() {
  const { language } = useLanguage();

  const contentEn = (
    <div className="space-y-6 text-sm text-muted-foreground leading-relaxed">
      <section className="space-y-3">
        <h2 className="text-xl font-bold text-[#2A0A10]">1. What Are Cookies?</h2>
        <p>
          Cookies are small text files stored on your computer or mobile device by websites you visit. They are widely used to make websites work more efficiently, improve browsing experience, and provide analytical data to website owners. Cookies can be "persistent" (saved on your device until they expire or you delete them) or "session" (deleted when you close your web browser).
        </p>
      </section>

      <section className="space-y-3">
        <h2 className="text-xl font-bold text-[#2A0A10]">2. How We Use Cookies</h2>
        <p>Hamarsathi.com uses cookies to optimize platform performance and secure user accounts. Specifically, we use cookies for:</p>
        <ul className="list-disc pl-5 space-y-1">
          <li><strong>Authentication & Login Status:</strong> To recognize you when you log in, so you do not have to re-enter your password on every page.</li>
          <li><strong>Security:</strong> To detect fraudulent activity, keep your login credentials secure, and prevent unauthorized account access.</li>
          <li><strong>Language Preferences:</strong> To remember whether you selected English or Hindi, maintaining your preference across browsing sessions.</li>
          <li><strong>Performance & Analytics:</strong> To understand how users interact with our website, identify loading speed issues, and optimize page layout.</li>
        </ul>
      </section>

      <section className="space-y-3">
        <h2 className="text-xl font-bold text-[#2A0A10]">3. Types of Cookies We Use</h2>
        <div className="space-y-2">
          <p>
            <strong>Essential Cookies:</strong> These are strictly necessary for the core functionality of the website. Without these cookies, services like secure login, premium billing, and privacy settings cannot function.
          </p>
          <p>
            <strong>Functional Cookies:</strong> These allow the website to remember choices you make (such as language selection or search filters) to provide a more personalized matchmaking experience.
          </p>
          <p>
            <strong>Analytical Cookies:</strong> We use mock or standard analytics tools (e.g., Google Analytics) to track pages visited, bounce rates, and traffic sources to continuously improve our matching service.
          </p>
        </div>
      </section>

      <section className="space-y-3">
        <h2 className="text-xl font-bold text-[#2A0A10]">4. How to Manage and Disable Cookies</h2>
        <p>
          Most web browsers automatically accept cookies, but you can modify your browser settings to block or delete cookies if you prefer. 
        </p>
        <p>
          Please note that if you choose to disable or block cookies, certain features of Hamarsathi.com (such as staying logged in, receiving real-time chat notifications, and saved search filters) may not function correctly.
        </p>
      </section>
    </div>
  );

  const contentHi = (
    <div className="space-y-6 text-sm text-muted-foreground leading-relaxed">
      <section className="space-y-3">
        <h2 className="text-xl font-bold text-[#2A0A10]">1. कुकीज़ क्या हैं?</h2>
        <p>
          कुकीज़ छोटी टेक्स्ट फाइलें होती हैं जिन्हें आपके द्वारा देखी जाने वाली वेबसाइटों द्वारा आपके कंप्यूटर या मोबाइल डिवाइस पर संग्रहीत किया जाता है। वेबसाइटों को अधिक कुशलता से काम करने, ब्राउज़िंग अनुभव को बेहतर बनाने और वेबसाइट मालिकों को विश्लेषणात्मक डेटा प्रदान करने के लिए इनका व्यापक रूप से उपयोग किया जाता है। कुकीज़ "स्थायी" (आपके डिवाइस पर संग्रहीत) या "सत्र" (ब्राउज़र बंद करने पर नष्ट) हो सकती हैं।
        </p>
      </section>

      <section className="space-y-3">
        <h2 className="text-xl font-bold text-[#2A0A10]">2. हम कुकीज़ का उपयोग कैसे करते हैं</h2>
        <p>हमरसाथी (Hamarsathi.com) प्लेटफ़ॉर्म के प्रदर्शन को अनुकूलित करने और उपयोगकर्ता खातों को सुरक्षित रखने के लिए कुकीज़ का उपयोग करता है। विशेष रूप से, हम कुकीज़ का उपयोग निम्न के लिए करते हैं:</p>
        <ul className="list-disc pl-5 space-y-1">
          <li><strong>प्रमाणीकरण और लॉगिन स्थिति:</strong> जब आप लॉग इन करते हैं तो आपकी पहचान करने के लिए, ताकि आपको हर पृष्ठ पर अपना पासवर्ड दोबारा दर्ज न करना पड़े।</li>
          <li><strong>सुरक्षा:</strong> धोखाधड़ी की गतिविधियों का पता लगाने, आपके लॉगिन क्रेडेंशियल को सुरक्षित रखने और अनधिकृत पहुंच को रोकने के लिए।</li>
          <li><strong>भाषा प्राथमिकताएं:</strong> यह याद रखने के लिए कि आपने अंग्रेजी या हिंदी चुनी है, ताकि आपकी पसंद बनी रहे।</li>
          <li><strong>प्रदर्शन और विश्लेषण:</strong> यह समझने के लिए कि उपयोगकर्ता हमारी वेबसाइट के साथ कैसे व्यवहार करते हैं, लोडिंग गति की समस्याओं की पहचान करने और पृष्ठ लेआउट को अनुकूलित करने के लिए।</li>
        </ul>
      </section>

      <section className="space-y-3">
        <h2 className="text-xl font-bold text-[#2A0A10]">3. कुकीज़ के प्रकार जिनका हम उपयोग करते हैं</h2>
        <div className="space-y-2">
          <p>
            <strong>आवश्यक कुकीज़ (Essential Cookies):</strong> ये वेबसाइट की मुख्य कार्यक्षमता के लिए सख्त रूप से आवश्यक हैं। इन कुकीज़ के बिना, सुरक्षित लॉगिन, प्रीमियम बिलिंग और गोपनीयता सेटिंग्स जैसी सेवाएं काम नहीं कर सकती हैं।
          </p>
          <p>
            <strong>कार्यात्मक कुकीज़ (Functional Cookies):</strong> ये वेबसाइट को आपके द्वारा चुने गए विकल्पों (जैसे भाषा चयन या खोज फ़िल्टर) को याद रखने की अनुमति देती हैं ताकि अधिक व्यक्तिगत अनुभव प्रदान किया जा सके।
          </p>
          <p>
            <strong>विश्लेषणात्मक कुकीज़ (Analytical Cookies):</strong> हम मिलान सेवा को लगातार बेहतर बनाने के लिए विज़िट किए गए पेजों, बाउंस दरों और ट्रैफ़िक स्रोतों को ट्रैक करने के लिए मानक विश्लेषण टूल का उपयोग करते हैं।
          </p>
        </div>
      </section>

      <section className="space-y-3">
        <h2 className="text-xl font-bold text-[#2A0A10]">4. कुकीज़ को कैसे प्रबंधित और निष्क्रिय करें</h2>
        <p>
          अधिकांश वेब ब्राउज़र स्वचालित रूप से कुकीज़ स्वीकार करते हैं, लेकिन यदि आप चाहें तो कुकीज़ को ब्लॉक करने या हटाने के लिए अपनी ब्राउज़र सेटिंग्स को संशोधित कर सकते हैं।
        </p>
        <p>
          कृपया ध्यान दें कि यदि आप कुकीज़ को अक्षम या ब्लॉक करना चुनते हैं, तो हमरसाथी की कुछ विशेषताएं (जैसे लॉग इन रहना, वास्तविक समय में चैट सूचनाएं प्राप्त करना और सहेजे गए खोज फ़िल्टर) ठीक से काम नहीं कर सकती हैं।
        </p>
      </section>
    </div>
  );

  return (
    <StaticPageLayout
      title={language === "hi" ? "कुकी नीति" : "Cookie Policy"}
      subtitle={language === "hi" ? "समझें कि हम कुकीज़ का उपयोग कैसे करते हैं" : "Understand how we use cookies"}
    >
      {language === "hi" ? contentHi : contentEn}
    </StaticPageLayout>
  );
}
